module.exports = __webpack_public_path__ + "img/amazed.60e561ee.png";